import config from '@saucelabs/sl-util-config';
import TestObjectClient from '@saucelabs/web-rdc-client';

export const connectDevice = ({ deviceSessionId, elementId }) => {
  const rdcApiUrl = config.apiBaseUrls.rdc;
  const cdnUrl = config.saucelabsCdnRoot;
  return TestObjectClient.connectDevice(cdnUrl, rdcApiUrl, deviceSessionId, elementId);
};
